var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduledCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.5V2.625H10.25V3.25H9V2.625H4V3.25H2.75V2.625H1.5V4.5H11.5ZM11.5 5.75H1.5V12H11.5V5.75ZM10.25 1.375H11.5C12.1904 1.375 12.75 1.93464 12.75 2.625V12C12.75 12.6904 12.1904 13.25 11.5 13.25H1.5C0.809644 13.25 0.25 12.6904 0.25 12V2.625C0.25 1.93464 0.809644 1.375 1.5 1.375H2.75V0.75H4V1.375H9V0.75H10.25V1.375ZM4.625 8.25H3.375V7H4.625V8.25ZM7.125 8.25H5.875V7H7.125V8.25ZM9.625 8.25H8.375V7H9.625V8.25ZM4.625 10.75H3.375V9.5H4.625V10.75ZM7.125 10.75H5.875V9.5H7.125V10.75Z",
    fill: "#007B23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledCalendar);
export default __webpack_public_path__ + "static/media/scheduled-calendar.98db014a690f514aaf4f0057c672a6f3.svg";
export { ForwardRef as ReactComponent };